import { ISubView } from "@ancademy/vse-client";
import { BargainView } from "./Bargin";
import { BuyCarView } from "./BuyCar";
import { BuyHouseView } from "./BuyHouse";
import { BuyInsuranceView } from "./BuyInsurance";
import { BuyTicketView } from "./BuyTicket";
import { ConceptView } from "./Concept";
import { FindJobView } from "./FindJob";
import { RentHouseView } from "./RentHouse";
import { SaleCarView } from "./SaleCar";
import { SaleFurnitureView } from "./SaleFurniture";
import { TradeCarView } from "./TradeCar";

export const subViewList: ISubView[] = [
  ConceptView,
  RentHouseView,
  FindJobView,
  BuyTicketView,
  BuyCarView,
  BuyInsuranceView,
  BuyHouseView,
  SaleFurnitureView,
  SaleCarView,
  TradeCarView,
  BargainView,
];
